/**
 * Every non-2xx response surfaces here. TanStack Query treats it as `error`; components
 * render an <ErrorState>. Global 401/403 handling lives in `client.ts` interceptors.
 */
export class ApiError extends Error {
  constructor(
    public readonly statusCode: number,
    public readonly code: string,
    message: string,
    public readonly detail?: unknown,
  ) {
    super(message)
    this.name = 'ApiError'
  }

  static fromUnknown(err: unknown): ApiError {
    if (err instanceof ApiError) return err
    if (err instanceof Error) {
      return new ApiError(0, 'UNKNOWN', err.message)
    }
    return new ApiError(0, 'UNKNOWN', 'Unknown error')
  }
}

/** Status code → user-facing fallback message. Prefer server-supplied `detail`/`description`
 *  when available; this is only used when the server response is opaque. */
export function statusMessage(statusCode: number): string {
  switch (statusCode) {
    case 400:
      return 'The request could not be processed.'
    case 401:
      return 'Session has ended. Please sign in again.'
    case 403:
      return 'You do not have permission to perform this action.'
    case 404:
      return 'The item you are looking for was not found.'
    case 409:
      return 'The item has been changed by someone else.'
    case 500:
    case 502:
    case 503:
    case 504:
      return 'The service is temporarily unavailable. Please retry.'
    default:
      return 'Something went wrong. Please retry.'
  }
}
